export default __webpack_public_path__ + "media/images/screen_interactions-9837dafaee30c5efee219d469acd1e84.svg";